import trainingRegistrationRouteGuard from './trainingRegistrationRouteGuard';

export default trainingRegistrationRouteGuard;
